/**
 * `mailto:` / `tel:` link targets, percent-encoded.
 *
 * NOT decoration, and not a style preference. Both schemes have their own syntax
 * INSIDE the part that looks like a plain address:
 *
 *   - `mailto:` treats `?` as the start of a header list (RFC 6068). An address
 *     stored as `x@y.com?cc=someone@else.com` yields a link that silently adds a
 *     recipient the sender never typed, and `?body=` prefills the message.
 *   - `tel:` takes `;`-delimited parameters (RFC 3966), including `;postd=` —
 *     post-dial digits. A number stored as `+18015550100;postd=pp9` dials extra
 *     digits after connecting.
 *
 * React escapes the ATTRIBUTE, which stops markup injection. It does not know that
 * `?` means something to a mail client or `;` to a dialer, so it cannot help here.
 *
 * WHY THIS LIVES IN A SHARED FILE. It started as a local helper inside
 * HotelContacts.tsx, added with the server-side validator that rejects these
 * characters on the way in. A pre-open review then found the identical raw sink
 * still in ContactCell (the Hotels table) and in HotelDetail — both reading
 * `hotel_master.contact_*`, which is synced from Domo and therefore never passes
 * through that validator at all. Two layers only help if the outer one is applied
 * everywhere, and "everywhere" is not a property a copied local function has.
 *
 * So: one function, one import, and a grep for `mailto:` or `tel:` in a template
 * literal is now a review smell rather than the norm.
 */
export function contactHref(scheme: 'mailto' | 'tel', value: string): string {
  return `${scheme}:${encodeURIComponent(value)}`;
}
